import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=3a20131a&scoped=true&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=3a20131a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20131a",
  null
  
)

component.options.__file = "breadcrumb.vue"
export default component.exports